import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/Home.css";
import logo from '../assets/images/logo.png';

function Home() {
    return (
        <div>
            <Header />
            <main>
                <div className="banner light-gray-bg">

                    <div className="columns is-vcentered big-margin">
                        <div className="column is-8">
                            <p className="big-title">
                                Milk Stars Enterprises
                            </p>
                            <br />
                            <p className="normal-text">
                                At Milk Stars Enterprises, we aim to make dairy farming more profitable and sustainable by providing seamless milk payment management. Our platform ensures accurate calculations, transparent transactions, and timely payouts for farmers. With a focus on efficiency and trust, we help dairy businesses thrive with smart financial solutions.
                            </p>

                        </div>
                        <div className="column">

                        </div>
                    </div>
                </div>

                <div className="primary-bg mb-4">
                    <div className="columns is-vcentered small-margin">
                        <div className="column pb-2 mt-3">
                            <div className="box">
                                <article className="media">
                                    <img src={logo} alt="" className="white-bg" />
                                </article>
                            </div>

                        </div>

                        <div className="column">
                            <div className="story-section">
                                <h1>Become a Member</h1>
                                <p>Join our network of dairy farmers and gain access to seamless milk payment processing, transparent financial records, and timely payouts to help you grow your business.</p>
                            </div>
                            <div className="story-section">
                                <h1>Reliable Payments</h1>
                                <p>We ensure fair and accurate milk price calculations, debt deductions, and payment scheduling, giving you peace of mind and financial stability.</p>
                            </div>
                            <div className="story-section">
                                <h1>Grow With Us</h1>
                                <p>Leverage our platform to track earnings, manage debts, and plan your finances effectively—because a thriving dairy business starts with smart financial management.</p>
                            </div>
                        </div>


                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default Home;
